export class FieldProperty {
  defaultValue: string;
  editor: string;
  editorUrl: string;
  fieldType: string;
  hints: string;
  inlineEditable: boolean;
  isListField: boolean;
  isReferenceField: boolean;
  isRequired: boolean;
  isUnique: boolean;
  label: string;
  maxLength: number;
  minLength: number;
  pattern: string;
  patternMessage: string;
  placeholder: string;
  mustBeImage: boolean;
  allowedExtensions: string[];
  allowDuplicates: boolean;
  resolveFirst: boolean;
  resolveImage: boolean;
  minItems: number;
  maxItems: number;
  allowedValues: string[];
  
  schemaIds: string[];
}
